// 홈 데스크톱 우측 사이드 컬럼 — 시안 C1 `.rcol` 3카드 (신고 371 §8).
// ① 검차정산 요약(기존 companySettlement 재사용) ② 최근 종료 5건 ③ 검차 신청 방법 안내.
import React from 'react';
import { T } from '../../../theme';
import { useT, useLocale } from '../../../../i18n/I18nProvider';
import { fmtDate, orderTitle, stripTrailingChevron } from '../../fmt';
import { describeSimpleError } from '../../errors';
import SideCard from '../../parts/SideCard';
import LtrText from '../../parts/LtrText';
import MoneyKRW from '../../parts/MoneyKRW';
import SimpleStatusPill from '../../parts/SimpleStatusPill';
import ErrorText from '../../parts/ErrorText';
import Thumb from './Thumb';

var sum = { padding: '13px 15px', display: 'flex', flexDirection: 'column', gap: 11 };
var sumDesc = { fontSize: 11.5, color: T.muted, lineHeight: 1.5 };
var figRow = { display: 'flex', alignItems: 'flex-end', gap: 14 };
var figLabel = { display: 'block', fontSize: 10.5, fontWeight: 700, color: T.faint };
var figValue = { display: 'block', fontSize: 21, fontWeight: 800, letterSpacing: '-.5px', lineHeight: 1.2 };
var figRight = { marginInlineStart: 'auto', textAlign: 'end', minWidth: 0 };

var compact = {
  display: 'flex', alignItems: 'center', gap: 9, padding: '7px 13px', minHeight: 44, width: '100%', minWidth: 0,
  boxSizing: 'border-box', border: 0, borderTop: '1px solid ' + T.bdSoft, background: T.card, cursor: 'pointer',
  fontFamily: 'inherit', textAlign: 'start'
};
var cTx = { flex: 1, minWidth: 0 };
var cTitle = { display: 'block', fontSize: 13, fontWeight: 700, color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var cDate = { display: 'block', fontSize: 11.5, color: T.muted, marginTop: 1 };


// simpleViewAll 은 문구 끝에 '›' 를 품고 있고 SideCard 는 자기 chevron SVG 를 붙인다 — 화살표 두 개가 되지 않게 글리프만 뗀다.
function viewAll(t) { return stripTrailingChevron(t('simpleViewAll')); }


/// props: { settle, finished, finishedCount, onFees, onGroup(group), onOpen(id) }
function HomeSide(props) {
  var t = useT();
  var loc = useLocale();
  var settle = props.settle || {};
  var finished = props.finished || [];
  var onOpen = props.onOpen;

  return (<React.Fragment>
    <SideCard title={t('shellTabSettlement')} linkLabel={viewAll(t)} onLink={props.onFees}>
      <div style={sum}>
        <div style={sumDesc}>{t('simpleB1SettleDesc')}</div>
        {settle.error ? <ErrorText>{describeSimpleError(t, settle.error)}</ErrorText> : (<div style={figRow}>
          <div style={{ minWidth: 0 }}>
            <span style={figLabel}>{t('simpleFeeCountLabel')}</span>
            <LtrText style={figValue}>{t('simpleInspectionsCount', { count: (settle.data && settle.data.count) || 0 })}</LtrText>
          </div>
          <div style={figRight}>
            <span style={figLabel}>{t('simpleFeeTotal')}</span>
            <MoneyKRW won={(settle.data && settle.data.total) || 0} style={Object.assign({}, figValue, { color: T.money })} />
          </div>
        </div>)}
      </div>
    </SideCard>

    <SideCard title={t('simpleGroupFinished')} count={props.finishedCount} linkLabel={viewAll(t)}
      onLink={function () { props.onGroup('finished'); }}>
      {finished.length === 0 ? <div style={Object.assign({}, sumDesc, { padding: '14px 15px' })}>{t('evalEmpty')}</div> : finished.map(function (o, i) {
        return (<button key={o.id} type="button" className="ss-crow" data-order-id={o.id}
          style={Object.assign({}, compact, i === 0 ? { borderTop: '1px solid transparent' } : null)}
          onClick={function () { onOpen(o.id); }}>
          <Thumb order={o} w={30} h={30} icon={15} />
          <span style={cTx}>
            <span style={cTitle}>{orderTitle(t, o)}</span>
            <LtrText style={cDate}>{fmtDate(loc.locale, o.inspect_date || o.created_at)}</LtrText>
          </span>
          <SimpleStatusPill status={o.status} />
        </button>);
      })}
    </SideCard>

  </React.Fragment>);
}

export default HomeSide;
